import { observer } from 'mobx-react';
import * as React from 'react';
import VisualizationEmbedState from './VisualizationEmbedState';
import VisualizationEmbedStore from '../../VisualizationEmbedStore';
import VisualizationEmbedReactions from '../../VisualizationEmbedStore/Reactions';
import { DashboardType } from '../../ReportStore/Types';

interface QuickSightParameter {
  Name: string;
  Values: string[];
}

interface Props {
  visualizationPath: string;
  height: string;
  width: string;
  name: string;
  onReady: () => void;
  dashboardType: DashboardType;
  onDashboardReady?: (dashboard: any) => void;
  parameters?: QuickSightParameter[];
}

class VisualizationEmbed extends React.Component<Props, {}> {
  visualizationEmbedStore: VisualizationEmbedStore = new VisualizationEmbedStore();

  componentDidMount() {
    this.visualizationEmbedStore.loading();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.visualizationPath !== this.props.visualizationPath) {
      this.visualizationEmbedStore.loading();
    }
  }

  render() {
    return (
      <>
        <VisualizationEmbedState
          store={this.visualizationEmbedStore}
          visualizationPath={this.props.visualizationPath}
          height={this.props.height}
          width={this.props.width}
          dashboardType={this.props.dashboardType}
          onReady={this.props.onReady}
          onDashboardReady={this.props.onDashboardReady}
          parameters={this.props.parameters}
        />
        <VisualizationEmbedReactions
          store={this.visualizationEmbedStore}
          dashboardType={this.props.dashboardType}
          visualizationPath={this.props.visualizationPath}
          fireImmediately={true}
        />
      </>
    );
  }
}

export default observer(VisualizationEmbed);
